<template>
  <div>
    <h1 class="text-center font-extrabold text-xl mb-5">
      <template v-if="edit">Modifier le profil de {{ profile.fullName }}</template>
      <template v-else>{{ $t("Add a user") }}</template>
    </h1>
    <div class="w-full">
      <div class="grid grid-cols-2 gap-4">
        <Selector id="role" :label="$t('Role')" name="role" v-model="role" :options="roles" />
        <MultiSelect
          v-if="!roleAdminSelected"
          id="stores"
          required
          :label="$t('Selling points')"
          :placeholder="$t('Select selling points')"
          v-model="storeIds"
          :options="storesOptions"
        />
        <div v-else></div>
        <div v-if="!edit">
          <FormField id="firstName" :label="$t('First Name')" name="firstName" required v-model="firstName" />
        </div>
        <div v-if="!edit">
          <FormField id="last_name" :label="$t('Last Name')" name="last_name" required v-model="lastName" />
        </div>
        <div v-if="!edit">
          <FormField id="email" :label="$t('Email Address')" name="email" required v-model="email" />
        </div>
      </div>

      <div class="mt-4 flex justify-end">
        <Loading v-if="isLoading" />
        <GenericButton v-else @click="submit">
          {{ $t("Validate") }}
        </GenericButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import GenericButton from "@/components/utils/GenericButton.vue";
import { FormField, Selector, Loading } from "@estaly/ui";
import MultiSelect from "@/components/utils/MultiSelect.vue";

export default {
  components: {
    FormField,
    GenericButton,
    Loading,
    Selector,
    MultiSelect,
  },
  props: {
    profile: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      edit: false,
      isLoading: false,
      firstName: "",
      lastName: "",
      email: "",
      storeIds: [],
      role: this.profile?.role,
      roles: [],
      storesOptions: [],
    };
  },
  computed: {
    roleAdminSelected() {
      return this.role === "organization_admin";
    },
  },
  created() {
    this.edit = !!this.profile;
    this.setupFormData();
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("merchantProfiles", {
      updateMerchantProfile: "update",
      newMerchantProfile: "new",
      createMerchantProfile: "create",
    }),
    async setupFormData() {
      this.isLoading = true;
      const response = await this.newMerchantProfile();
      this.isLoading = false;
      if (!response) return;

      const { roles, stores } = response;
      this.roles = roles;
      this.storesOptions = stores.map((store) => ({
        value: store.id,
        label: store.name,
      }));
      this.role ||= this.roles[0].value;
      const salesChannels = this.profile?.stores?.map((store) => store.salesChannel) || [];
      this.storeIds = this.storesOptions
        .filter((option) => salesChannels.includes(option.label))
        .map((option) => option.value);
    },
    async submit() {
      this.edit ? await this.update() : await this.create();
    },
    async update() {
      this.isLoading = true;
      const success = await this.updateMerchantProfile({
        id: this.profile.id,
        storeIds: this.storeIds,
        role: this.role,
      });
      this.isLoading = false;
      if (!success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
      this.$emit("success");
    },
    async create() {
      this.isLoading = true;
      const success = await this.createMerchantProfile({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        storeIds: this.storeIds,
        role: this.role,
      });
      this.isLoading = false;
      if (!success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Utilisateur créé",
        text: "Un email d'invitation a été envoyé à l'utilisateur",
      });
      this.$emit("success");
    },
  },
};
</script>
